export default "__VITE_ASSET__38qq3m7s__"